import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Layout from './components/Layout';
import MyExpenses from './pages/MyExpenses';
import SubmitExpense from './pages/SubmitExpense';
import MyReports from './pages/MyReports';
import Settings from './pages/Settings';
import Admin from './pages/Admin';
import AdminExpenses from './pages/AdminExpenses';
import GetToken from './pages/GetToken';

const App = () => {
  const token = localStorage.getItem('token');

  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={!token ? <Login onLogin={(user) => localStorage.setItem('userEmail', user.email)} /> : <Navigate to="/my-expenses" />} />
        <Route path="/register" element={!token ? <Register /> : <Navigate to="/my-expenses" />} />
        
        {/* Special route for iOS Shortcut - handles its own auth */}
        <Route path="/submit-expense" element={<SubmitExpense />} />
        
        {/* Protected routes with sidebar layout */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/my-expenses" />} />
          <Route path="my-expenses" element={<MyExpenses />} />
          <Route path="my-reports" element={<MyReports />} />
          <Route path="settings" element={<Settings />} />
          <Route path="admin" element={<Admin />} />
          <Route path="admin-expenses" element={<AdminExpenses />} />
          <Route path="get-token" element={<GetToken />} />
          {/* Legacy dashboard route redirect */}
          <Route path="dashboard" element={<Navigate to="/my-expenses" replace />} />
        </Route>
        
        {/* Fallback redirect */}
        <Route path="*" element={<Navigate to={token ? "/my-expenses" : "/login"} />} />
      </Routes>
    </Router>
  );
};

export default App;